<script>
  import { fade } from "svelte/transition";
  import Img from "../../components/Img.svelte";
  import Load from "../../components/Load.svelte";
  import format from "number-format.js";
  import { redirect } from "../../pager";
  import Alert from "../../components/Alert.svelte";
  import Navigationbar from "../../components/Navigationbar.svelte";
  import Maproute from "../../components/map/Maproute.svelte";
  import Modal from "../../components/Modal.svelte";

  //liblary
  import axios from "axios";
  import { session, notif } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  let notify;
  notif.subscribe((value) => {
    notify = value;
  });
  export let data;
  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  //navigation
  let navigation = [];
  if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }
  //alert
  let alert = [];
  let loading = false;
  let itemsOrderDisplay = false;
  let loadOrder = "block";
  let itemsOrder = [];

  if (data) {
    loadTransaction(data.status);
  } else {
    loadTransaction("all");
  }
  function loadTransaction(status = "all") {
    itemsOrderDisplay = false;
    loadOrder = "block";
    axios
      .get(settings.url + "/sipade/kirimin/" + status, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        itemsOrder = response.data.data;
        itemsOrderDisplay = true;
        loadOrder = "hidden";
        setTimeout(() => {
          btnfilterActivate(status);
        }, 500);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }

  function btnfilterActivate(id) {
    Array.from(document.getElementsByClassName("btnfilter")).forEach((el) => {
      el.classList.remove("bg-opacity-100");
    });
    if (id) {
      if (document.getElementById("btnfilter-" + id)) {
        if (document.getElementById("btnfilter-" + id).classList != null) {
          document
            .getElementById("btnfilter-" + id)
            .classList.add("bg-opacity-100");
        }
      }
    } else {
      this.classList.add("bg-opacity-100");
    }
  }
  function statusUpdate(id, status) {
    loading = true;
    axios
      .post(
        settings.url + "/sipade/orderstatus?authorization=" + settings.token,
        {
          transactionID: id,
          status: status,
        }
      )
      .then(function (response) {
        loadTransaction("accept");
        document.getElementById("btnfilter-accept").click();
        loading = false;
      })
      .catch(function (error) {
        loading = false;
        if (error.response.status == 400) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message:
                "Kamu belum bisa ambil tugas lagi, Masih ada tugas yang belum terselesaikan",
              color: "orange",
            },
          ];
        } else if (error.response.status == 401) {
          localStorage.removeItem("t");

          redirect("/login");
        } else {
          window.location.reload();
        }
      });
  }
  $: lat = "";
  $: lang = "";
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      x.innerHTML = "Geolocation is not supported by this browser.";
    }
  }

  function showPosition(position) {
    lat = position.coords.latitude;
    lang = position.coords.longitude;
  }
  getLocation();
</script>

<svelte:head>
  <title>Ngirim Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar
  backbtn="true"
  message={navigation["message"]}
  title="Tugas Ngirim"
/>

<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="flex">
    <div class="w-full px-2 mx-auto lg:my-5">
      <div
        style="top:100px"
        class="w-full p-2 mt-5 overflow-x-auto bg-white rounded-lg shadow-xl lg:sticky"
      >
        <div class="flex flex-wrap items-center mx-auto">
          <div class="w-1/2 px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
            <a
              on:click={() => loadTransaction("all")}
              id="btnfilter-all"
              class="block px-4 py-3 text-green-100 bg-green-600 bg-opacity-50 rounded-lg shadow-md cursor-pointer btnfilter group lg:rounded-full hover:shadow-lg"
              href="/ngirim/all"
            >
              <div class="text-center">
                <h1 class="text-sm font-semibold group-hover:text-green-700">
                  Temukan Tugas
                </h1>
              </div>
            </a>
          </div>

          <div class="w-1/2 px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
            <a
              on:click={() => loadTransaction("accept")}
              id="btnfilter-accept"
              class="block px-4 py-3 text-blue-100 bg-blue-600 bg-opacity-50 rounded-lg shadow-md cursor-pointer btnfilter group lg:rounded-full hover:shadow-lg"
              href="/ngirim/accept"
            >
              <div class="text-center">
                <h1 class="text-sm font-semibold group-hover:text-green-700">
                  Tugasku
                  {#if notify}
                    {#if notify.ship_accepted_wait > 0}
                      <span
                        class="inline px-2 font-mono text-xs font-normal text-center text-white bg-red-500 rounded-full"
                      >
                        {notify.ship_accepted_wait}
                      </span>
                    {/if}
                  {/if}
                </h1>
              </div>
            </a>
          </div>
        </div>
      </div>
      {#if itemsOrderDisplay}
        <div class="w-full mt-5">
          {#if itemsOrder.length > 0}
            {#each itemsOrder as it}
              <section
                class="w-full px-5 py-2 my-5 text-sm bg-white rounded-lg shadow-lg"
              >
                <div class="flex justify-between py-2 border-b">
                  <div class="text-xs font-light text-gray-600">
                    {it.date}
                    WIB
                  </div>
                  <div class="">
                    <div
                      class="px-2 text-xs font-light text-gray-600 bg-green-200 rounded-lg"
                    >
                      {it.pay_method}
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-wrap justify-between py-2 mx-auto lg:my-0"
                >
                  <div class="w-1/2 lg:w-2/12">
                    <div class="px-2">
                      <div class="text-xs">Ongkos Pengiriman</div>
                      <div>
                        <span class="font-bold text-green-600">
                          {format("Rp.#.###,", it.shipment)}
                        </span>
                        <span class="font-light"
                          >({it.details.summary.ship_distance}
                          KM)</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="w-1/2 lg:w-2/12">
                    <div class="px-2">
                      <span class="text-xs">Belanjaan</span>
                      <div class="font-bold text-green-600">
                        {format("Rp.#.###,", it.pricing)}
                      </div>
                    </div>
                  </div>
                  <div class="w-1/2 lg:w-2/12">
                    <div class="px-2">
                      <span class="text-xs">Total Belanja</span>
                      <div class="font-bold text-green-600">
                        {format("Rp.#.###,", it.total)}
                      </div>
                    </div>
                  </div>

                  <div class="w-1/2 px-2 border-l lg:w-3/12">
                    <div class="text-xs">Status</div>
                    <div class="font-bold">
                      {#if it.status == 0}Pesanan Baru{/if}
                      {#if it.status == 100}Pesanan Diproses{/if}
                      {#if it.status == 200}Proses Pengiriman{/if}
                      {#if it.status == 300}Pengiriman Disiapkan{/if}
                      {#if it.status == 301}Penjemputan Paket{/if}
                      {#if it.status == 302}Pengiriman Paket Terkonfirmasi{/if}
                      {#if it.status == 303}Paket Dalam Perjalanan{/if}
                      {#if it.status == 304}Resi Tidak Valid{/if}
                      {#if it.status == 305}Resi Diubah{/if}
                      {#if it.status == 306}Menunggu Pengambilan{/if}
                      {#if it.status == 307}Dikembalikan{/if}
                      {#if it.status == 308}Menunggu Konfirmasi Penerimaan{/if}
                      {#if it.status == 309}Pesanan Dikomplain{/if}
                      {#if it.status == 400}Pesanan Selesai{/if}
                      {#if it.status == 500}Pesanan Dibatalkan{/if}
                      {#if it.status == 600}Pesanan Dikembalikan{/if}
                    </div>
                  </div>
                  <div class="w-full lg:w-3/12">
                    <div class="px-2">
                      <div>
                        {#if it.status == 200}
                          <button
                            on:click={() =>
                              document
                                .getElementById("bukaDetail-" + it.ID)
                                .click()}
                            class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Ambil Tugas</span></button
                          >
                        {/if}
                        {#if it.status == 300}
                          <button
                            on:click={() =>
                              document
                                .getElementById("bukaDetail-" + it.ID)
                                .click()}
                            class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Saya Menuju Ke Penjual</span></button
                          >
                        {/if}
                        {#if it.status == 301}
                          <button
                            on:click={() =>
                              document
                                .getElementById("bukaDetail-" + it.ID)
                                .click()}
                            class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Paket Sudah Disaya</span></button
                          >
                        {/if}
                        {#if it.status == 302}
                          <button
                            on:click={() =>
                              document
                                .getElementById("bukaDetail-" + it.ID)
                                .click()}
                            class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Saya Menuju Ke Pembeli</span></button
                          >
                        {/if}
                        {#if it.status == 303}
                          <button
                            on:click={() =>
                              document
                                .getElementById("bukaDetail-" + it.ID)
                                .click()}
                            class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Paket Diterima Pembeli</span></button
                          >
                        {/if}
                        {#if it.status == 304}Resi Tidak Valid{/if}
                        {#if it.status == 305}Resi Diubah{/if}
                        {#if it.status == 306}Menunggu Pengambilan{/if}
                        {#if it.status == 307}Dikembalikan{/if}
                        {#if it.status == 308}
                          Menunggu Konfirmasi Penerimaan
                        {/if}
                        {#if it.status == 309}Pesanan Dikomplain{/if}
                        {#if it.status == 400}Pesanan Selesai{/if}
                        {#if it.status == 500}Pesanan Dibatalkan{/if}
                        {#if it.status == 600}Pesanan Dikembalikan{/if}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="py-2 border-t body">
                  {#each it.details.products as p}
                    <div class="w-full py-2 border-b">
                      <div>
                        <div class="flex justify-between w-full">
                          <div class="w-16">
                            <Img
                              csscont="none"
                              showplaceholder="false"
                              id={p.details.name}
                              datasrc="https://pics.dekatan.com/{p.pictures
                                .fileName}"
                              css="rounded-lg shadow"
                              alt="img-product"
                            />
                          </div>
                          <div class="w-full px-2">
                            <div class="font-bold text-blue-500">
                              <div>{p.details.name}</div>
                            </div>
                            <div class="font-light">
                              <span class="w-full pr-2 text-green-600">
                                {format("Rp.#.###,", p.details.price)}</span
                              ><span class="w-full text-gray-600"
                                >{p.quantity}
                                Produk</span
                              >
                            </div>
                          </div>
                          <div class="w-2/5 px-2 border-l">
                            <div class="text-xs ellipsis-2">
                              Total Harga Produk
                            </div>
                            <div
                              class="font-normal text-green-600 lg:font-bold"
                            >
                              {format("Rp.#.###,", p.subtotal)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  {/each}

                  <div class="w-full py-2 border-b">
                    <div class="w-full my-2">
                      <Modal backdropClose size="lg:w-3/5 w-full">
                        <div class="text-center" slot="trigger" let:open>
                          <button
                            id="bukaDetail-{it.ID}"
                            on:click={open}
                            class="px-4 py-1 mx-1 my-1 text-gray-200 bg-green-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                            ><span>Buka Detail</span></button
                          >
                        </div>
                        <div slot="header">
                          <h1 class="text-lg">Detail Tugas</h1>
                          Berikut adalah rincian tugas pengiriman
                        </div>
                        <div slot="content" class="h-auto">
                          <div class="w-full h-auto">
                            <div
                              class="sticky top-0 z-10 flex items-center w-full gap-1 px-2 py-2 mx-auto text-left bg-white lg:my-0"
                            >
                              <div
                                class="p-3 rounded shadow lg:w-4/12 hover:shadow-lg"
                                title="Jarak {it.details.summary
                                  .ship_distance} Km"
                              >
                                <div class="text-xs">Ongkos Pengiriman</div>
                                <div>
                                  <span class="font-bold text-green-600">
                                    {format("Rp.#.###,", it.shipment)}
                                  </span>
                                </div>
                              </div>
                              <div
                                class="p-3 rounded shadow lg:w-4/12 hover:shadow-lg"
                                title="Jumlah yang harus anda bayar ke penjual"
                              >
                                <span class="text-xs">Belanjaan</span>
                                <div class="font-bold text-green-600">
                                  {format("Rp.#.###,", it.pricing)}
                                </div>
                              </div>
                              <div
                                class="p-3 rounded shadow lg:w-4/12 hover:shadow-lg"
                                title="Jumlah yang anda terima dari pembeli"
                              >
                                <span class="text-xs">Total Belanja</span>
                                <div class="font-bold text-green-600">
                                  {format("Rp.#.###,", it.total)}
                                </div>
                              </div>
                            </div>

                            <div class="w-full">
                              <div class="w-full">
                                {#if it.status != 100 || it.status != 0}
                                  {#if it.status != 400}
                                    <div
                                      class="p-4 mr-4 font-light text-green-700 bg-green-100 border-l-4 border-green-600 rounded-lg shadow lg:mx-2"
                                    >
                                      <span class="font-normal"
                                        >Perhatikan Langkahnya...!</span
                                      ><br />
                                      <ul class="list-outside">
                                        {#if it.status == 0}&nbsp;{/if}
                                        {#if it.status == 100}&nbsp;{/if}
                                        {#if it.status == 200}
                                          <li class="my-1">
                                            Sebelum ambil tugas ini, pahamilah
                                            bahwa kamu harus membayar belanjaan
                                            senilai
                                            <b
                                              >{format(
                                                "Rp.#.###,",
                                                it.pricing
                                              )}</b
                                            >
                                            saat paket diambil dari penjual, kamu
                                            akan mendapat penghasilan sebesar
                                            <b
                                              >{format(
                                                "Rp.#.###,",
                                                it.total
                                              )}</b
                                            >
                                            (<i
                                              >ongkos kirim + nilai belanjaan</i
                                            >) setelah kamu mengantarnya hingga
                                            paket diterima dan dibayar oleh
                                            pembeli. Jika sudah siap, silahkan
                                            ambil tugas dengan klik tombol
                                            dibawah ini

                                            <hr class="my-2" />
                                            <button
                                              on:click|preventDefault={() =>
                                                statusUpdate(it.ID, 300)}
                                              class="w-full px-4 py-2 my-1 text-lg font-bold text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                                              ><span>Ambil Tugas</span></button
                                            >
                                          </li>
                                        {/if}
                                        {#if it.status == 300}
                                          <li class="my-1">
                                            Klik tombol dibawah jika kamu mau
                                            jalan menuju ke lokasi penjual,
                                            gulir ke bawah untuk melihat
                                            informasi alamat penjual
                                            <hr class="my-2" />
                                            <button
                                              on:click|preventDefault={() =>
                                                statusUpdate(it.ID, 301)}
                                              class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                                              ><span
                                                >Saya Menuju Ke Penjual</span
                                              ></button
                                            >
                                          </li>
                                        {/if}
                                        {#if it.status == 301}
                                          <li class="my-1">
                                            Sampaikan detail paket yang hendak
                                            dijemput kepada penjual, Klik tombol
                                            dibawah jika paket sudah kamu terima
                                            untuk dicek terlebih dahulu
                                            <hr class="my-2" />
                                            <button
                                              on:click|preventDefault={() =>
                                                statusUpdate(it.ID, 302)}
                                              class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                                              ><span>Paket Sudah Disaya</span
                                              ></button
                                            >
                                          </li>
                                        {/if}
                                        {#if it.status == 302}
                                          <li class="my-1">
                                            Periksa dan pastikan paket yang kamu
                                            terima dari penjual sudah sesuai,
                                            Bayarlah sejumlah harga pesanan
                                            <b
                                              >({format(
                                                "Rp.#.###,",
                                                it.pricing
                                              )})</b
                                            >
                                            lalu klik tombol dibawah ini untuk mulai
                                            pengiriman

                                            <hr class="my-2" />
                                            <button
                                              on:click|preventDefault={() =>
                                                statusUpdate(it.ID, 303)}
                                              class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                                              ><span
                                                >Saya Menuju Ke Pembeli</span
                                              ></button
                                            >
                                          </li>
                                        {/if}
                                        {#if it.status == 303}
                                          <li class="my-1">
                                            Segera antarkan paket ke lokasi
                                            pembeli, gulir ke bawah untuk
                                            melihat informasi alamat
                                            pembeli/tujuan pengiriman dan jika
                                            paket sudah kamu serahkan kepada
                                            pembeli, terimalah bayaran sesuai
                                            nilai transaksi
                                            <b
                                              >({format(
                                                "Rp.#.###,",
                                                it.total
                                              )})</b
                                            >, lalu silakan klik tombol dibawah
                                            ini

                                            <hr class="my-2" />

                                            <button
                                              on:click|preventDefault={() =>
                                                statusUpdate(it.ID, 308)}
                                              class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                                              ><span
                                                >Paket Diterima Pembeli</span
                                              ></button
                                            >
                                          </li>
                                        {/if}
                                        {#if it.status == 304}&nbsp;{/if}
                                        {#if it.status == 305}&nbsp;{/if}
                                        {#if it.status == 306}&nbsp;{/if}
                                        {#if it.status == 307}&nbsp;{/if}
                                        {#if it.status == 308}
                                          Sampaikan agar pembeli mengkonfirmasi
                                          penerimaan melalui aplikasi
                                        {/if}
                                        {#if it.status == 309}&nbsp;{/if}
                                        {#if it.status == 400}&nbsp;{/if}
                                        {#if it.status == 500}&nbsp;{/if}
                                        {#if it.status == 600}&nbsp;{/if}
                                      </ul>
                                    </div>
                                  {:else}
                                    <div
                                      class="p-4 mr-4 font-light text-green-700 bg-green-100 border-l-4 border-green-600 rounded-lg shadow lg:mx-2"
                                    >
                                      <span class="font-bold"
                                        >Tugas Sudah Selesai</span
                                      >
                                    </div>
                                  {/if}
                                {/if}

                                <div
                                  class="flex flex-wrap items-center max-w-3xl mx-auto"
                                >
                                  <ul class="w-full timeline">
                                    <Modal backdropClose size="lg:w-3/4 w-full">
                                      <li slot="trigger" let:open>
                                        <div
                                          class="flex items-center justify-center bg-orange-600 timeline-badge"
                                        >
                                          A
                                        </div>
                                        <div
                                          on:click={open}
                                          class="relative p-4 mb-5 text-gray-700 bg-orange-100 rounded-lg shadow cursor-pointer timeline-panel easeAnimate hover:shadow-md"
                                          title="Lihat Rute Peta"
                                        >
                                          <div
                                            class="font-normal pointer timeline-heading"
                                          >
                                            <div>
                                              <small
                                                class="float-right px-2 py-1 text-white bg-orange-500 rounded-full shadow-outline"
                                                >Penjual</small
                                              >
                                              <b>{it.details.shop.nameShop}</b>
                                            </div>
                                            <div>
                                              <p class="mb-2">
                                                Kontak :
                                                <a
                                                  href="https://wa.me/{it
                                                    .details.shop
                                                    .address_phone}"
                                                  class="px-2 text-white bg-green-600 rounded"
                                                  target="_blank"
                                                  >{it.details.shop
                                                    .address_phone}</a
                                                ><br /><br />
                                                <small
                                                  >Alamat dalam peta :</small
                                                ><br />
                                                <span
                                                  >{it.details.summary.from
                                                    .geocode
                                                    .formatted_address}</span
                                                ><br />
                                                <small>Alamat tertulis :</small
                                                ><br />
                                                <span
                                                  >{it.details.shop
                                                    .address_name}</span
                                                ><br />
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>

                                      <div slot="header">
                                        <h1 class="text-lg">
                                          Rute Dari Posisi Saat Ini Ke Penjual
                                        </h1>
                                        <a
                                          target="_blank"
                                          class="px-2 py-1 text-white bg-blue-500 rounded shadow"
                                          href="https://www.google.com/maps/dir/{lat},{lang}/{it
                                            .details.shop.latitude},{it.details
                                            .shop.longtitude}">Buka Map</a
                                        >
                                      </div>
                                      <div slot="content" class="h-full">
                                        <Maproute
                                          latlang="{it.details.shop
                                            .longtitude},{it.details.shop
                                            .latitude};{lang},{lat}"
                                          icon="ship"
                                        />
                                      </div>
                                    </Modal>

                                    <Modal backdropClose size="lg:w-3/4 w-full">
                                      <li slot="trigger" let:open>
                                        <div
                                          class="flex items-center justify-center bg-blue-600 timeline-badge"
                                        >
                                          B
                                        </div>
                                        <div
                                          on:click={open}
                                          class="relative p-4 mb-5 text-gray-700 bg-blue-100 rounded-lg shadow cursor-pointer timeline-panel easeAnimate hover:shadow-md"
                                          title="Lihat Rute Peta"
                                        >
                                          <div
                                            class="font-normal pointer timeline-heading"
                                          >
                                            <div>
                                              <small
                                                class="float-right px-2 py-1 text-white bg-blue-500 rounded-full shadow-outline"
                                                >Pembeli</small
                                              >
                                              <b
                                                >{it.details.ship
                                                  .nama_penerima}</b
                                              >
                                            </div>
                                            <div>
                                              <p class="mb-2">
                                                Kontak :
                                                <a
                                                  href="https://wa.me/{it.buyer
                                                    .hp}"
                                                  class="px-2 text-white bg-green-600 rounded"
                                                  target="_blank"
                                                  >{it.buyer.hp}</a
                                                ><br /><br />
                                                <small
                                                  >Alamat dalam peta :</small
                                                ><br />
                                                <span
                                                  >{it.details.summary.to
                                                    .geocode
                                                    .formatted_address}</span
                                                ><br />
                                                <small>Alamat tertulis :</small
                                                ><br />
                                                <span
                                                  >{it.details.ship
                                                    .address}</span
                                                ><br />
                                                <span class="italic"
                                                  >({it.details.ship
                                                    .catatan})</span
                                                >
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <div slot="header">
                                        <h1 class="text-lg">
                                          Rute Dari Penjual Ke Pembeli
                                        </h1>
                                        <a
                                          target="_blank"
                                          class="px-2 py-1 text-white bg-blue-500 rounded shadow"
                                          href="https://www.google.com/maps/dir/{it
                                            .details.shop.latitude},{it.details
                                            .shop.longtitude}/{it.details.ship
                                            .latitude},{it.details.ship
                                            .longtitude}">Buka Map</a
                                        >
                                      </div>
                                      <div slot="content" class="h-full">
                                        <Maproute
                                          latlang={it.details.summary.latlng}
                                          icon="pickup"
                                        />
                                      </div>
                                    </Modal>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                      <p class="text-center">
                        <span class="text-xs font-light text-gray-600"
                          >({it.inv})</span
                        >
                      </p>
                    </div>
                    <div class="flex ">
                      <div class="w-5/12 text-xs text-gray-600">
                        <Modal backdropClose size="lg:w-2/5 w-full">
                          <div slot="trigger" let:open>
                            <p
                              class="text-right cursor-pointer"
                              on:click={open}
                            >
                              <span class="font-bold"
                                >{it.details.shop.nameShop}</span
                              >
                              <br />
                              {it.details.shop.address_name}
                            </p>
                          </div>
                          <div slot="header">
                            <h1 class="text-lg">Alamat Penjual</h1>
                            Lakukan penjemputan ke alamat dibawah ini
                          </div>
                          <div slot="content" class="h-full">
                            <div class="w-full h-full">
                              <br /><br />
                              <span class="text-base font-bold"
                                >{it.details.shop.nameShop}</span
                              ><br />
                              Kontak :
                              <a
                                href="https://wa.me/{it.details.shop
                                  .address_phone}"
                                class="px-2 text-white bg-green-600 rounded"
                                target="_blank"
                                >{it.details.shop.address_phone}</a
                              ><br /><br />
                              Alamat Diberikan Oleh Penjual :<br />
                              <span class="font-bold">
                                {it.details.shop.address_name}</span
                              ><br />
                            </div>
                          </div>
                        </Modal>
                      </div>
                      <div class="items-center w-2/12 px-5 text-center">
                        <div class="text-xs text-gray-600">--- KE ---</div>
                      </div>
                      <div class="w-5/12 text-xs text-left text-gray-600">
                        <Modal backdropClose size="lg:w-2/5 w-full">
                          <div slot="trigger" let:open>
                            <p class="cursor-pointer" on:click={open}>
                              <span class="font-bold"
                                >{it.details.ship.nama_penerima}</span
                              >
                              <br />
                              {it.details.ship.address}
                            </p>
                          </div>
                          <div slot="header">
                            <h1 class="text-lg">Alamat Pembeli</h1>
                            Lakukan pengiriman ke alamat dibawah ini
                          </div>
                          <div slot="content" class="h-full">
                            <div class="w-full h-full">
                              <br /><br />
                              <span class="text-base font-bold"
                                >{it.details.ship.nama_penerima}</span
                              ><br />

                              Kontak :
                              <a
                                href="https://wa.me/{it.buyer.hp}"
                                class="px-2 text-white bg-green-600 rounded"
                                target="_blank">{it.buyer.hp}</a
                              ><br /><br />
                              Alamat Diberikan Oleh Pembeli :<br />
                              <span class="font-bold">
                                {it.details.ship.address}</span
                              ><br />
                              <span class="italic"
                                >({it.details.ship.catatan})</span
                              ><br /><br />
                              Alamat Dalam Kordinat Peta :<br />
                              <span class="font-bold">
                                {it.details.summary.to.geocode
                                  .formatted_address}</span
                              >
                            </div>
                          </div>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            {/each}
          {:else}
            <p
              class="w-full p-5 font-light text-center text-gray-500 bg-white rounded shadow-md"
            >
              Belum ada tugas Ngirim
            </p>
          {/if}
        </div>
      {:else}
        <Load />
      {/if}
      {#if loading}
        <Load />
      {/if}
    </div>
  </div>
</main>
